const Form072PICSSC = {
    picsTitle: "个人资料收集声明",
    subtitleList: [
        { text: "收集个人资料的目的" },
        { text: "可获转移资料者" },
        { text: "查阅个人资料" },
    ],
    symbolStep: [{ step: "(a)" }, { step: "(b)" }, { step: "(c)" }],
    firstStep: [
        {
            text: "你在本表格提供的个人资料，会供教育局用于通函所提及的用途，以及执行教育相关的规则及规例，包括《教育条例》（香港法例第279章）。",
        },
        {
            text: "你必须按本表格的要求及于本局处理本表格的过程中提供个人资料。假如你没有提供该等个人资料，本局可能无法办理或继续处理本表格。",
        },
        {
            text: "你提供的个人资料会供教育局人员取阅。除此之外，本局亦可能会向下列各方或在下述情况转移或披露该等个人资料：",
        },
        {
            text: "你有权要求查阅及更正教育局所持有关于你的个人资料。如需查阅或更正个人资料，请以书面向助理教育主任（学校行政）42 提出（地址：香港添马添美道2号政府总部东翼5楼或电邮：<a href='mailto: aeosa42@edb.gov.hk'>aeosa42@edb.gov.hk</a>）。",
        },
    ],
    secondStep: [],
    thirdStep: [
        {
            text: "政府其他政策局及部门以用于上文第1段所述的用途；",
        },
        {
            text: "你曾就披露个人资料给予订明同意；以及",
        },
        {
            text: "根据适用于香港的法例或法庭命令授权或规定披露个人资料。",
        },
    ],
};
export default Form072PICSSC;
